import React, { Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { compose } from 'recompose';

import withTranslation from './utils/Translation/withTranslation';
import withBankingType from './utils/BankingType/withBankingType';
import withCategoryDemo from './utils/CategoryDemo/withCategoryDemo';

import HomePage from './pages/Home';
import Category from './pages/Category';
import Demo from './pages/Demo';
import IFrameVariant from './pages/IFrameVariant';
import ErrorGeneric from './pages/ErrorGeneric';
import Header from './components/Header/Header';
import { IsPending, Error, removeHashBang } from './utils/SiteTools';
import { lobSourceName, lobDemoSplit } from './utils/LobLogicModule';
import useAxios from './utils/hooks/useAxios';
import * as SELECTORS from './constants/selectors';
import './styles/base.scss';

function App() {
    const routeRegEx = new RegExp(process.env.REACT_APP_REGEX_DEMO_ROUTE);
    const sourceName = lobSourceName;
    const demoSplit = lobDemoSplit;

    removeHashBang();

    // Got all Categories for ROUTES and store in categoriesRoutes
    const { data, isPending, error } = useAxios(process.env.REACT_APP_GCDEV_API_CATEGORY_LIST+sourceName);
    const categoriesRoutes = (data && !data.error) ? data.map(item => `/${item.path}`) : [];
    return (
        <Fragment>
            { isPending && <IsPending /> }
            { (error || data?.error) && <Error errorMessage={error || data.error.message} /> }

            { (data && !data.error) && <Router basename={process.env.REACT_APP_BASENAME}>
                <Header selectorKey={SELECTORS.PAGE_NO_ADA_KEY} categoriesData={data} />
                <Switch>
                    <Route exact path={["/", "/fc"]} component={HomePage} />
                    {/* temporary Small Business category page redirection */}
                    <Route exact path={["/sb", "/sb/"]}>
                        <Redirect from="/sb/" to="/sb/smallbusiness" component={Category}  />
                    </Route>
                    {/* passed categoriesRoutes array for cateroy landing pages */}
                    <Route path={categoriesRoutes} component={Category} />
                    {categoriesRoutes.map((path, index) =>
                        <Route path={demoSplit+path} component={Category} key={index} />
                    )}
                    <Route path="/iframe/:bankingType/:demoRoute" component={IFrameVariant} />
                    <Route path="/sb/iframe/:bankingType/:demoRoute" component={IFrameVariant} />
                    <Route path="/fc/iframe/:bankingType/:demoRoute" component={IFrameVariant} />
                    
                    <Route path="/404" component={() => (<ErrorGeneric errorCode="404" />)}/>
                    <Route path={demoSplit+"/:demoRoute"} render={({ match }) => routeRegEx.test(match.params.demoRoute) ? <Demo match={match} /> : <Redirect from="*" to="/404" /> }/>
                    <Redirect from="*" to="/404" />
                    
                    <Route path="/102" component={() => (<ErrorGeneric errorCode="102" />)}/>
                </Switch>
            </Router> }
        </Fragment>
    );
}

export default compose(withTranslation, withBankingType, withCategoryDemo)(App);
